const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

enum CustomerType {
  Homeowner,
  Organization,
}

export { SUPPORTED_FORMATS, CustomerType };
